import React from "react";
import PropTypes from "prop-types";
import {Paper, Table, TableBody, TableCell, TableHead, TableRow} from "@material-ui/core";
import moment from "moment/moment";
import {useTranslation} from "react-i18next";

const MobileUserAccountPaymentDemandsList = ({notifications}) => {

  const {t} = useTranslation();

  if (notifications.length === 0) {
    return (<Paper style={{padding: 16, marginTop: 15}}>Brak wysłanych wezwań</Paper>)
  }

  return (
    <Paper style={{padding: 16, marginTop: 15}}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Data wysłania</TableCell>
            <TableCell>Wysłano do</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Aktualizacja</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {notifications.map(x => {
            return (
              <TableRow key={x.sentAt}>
                <TableCell>{moment(x.sentAt).local().format('DD.MM.YYYY HH:mm')}</TableCell>
                <TableCell>{x.sentTo}</TableCell>
                <TableCell>{t(`mobileUserAccounts.paymentDemands.status.${x.status}`)}</TableCell>
                <TableCell>{x.updatedAt ? moment(x.sentAt).local().format('DD.MM.YYYY HH:mm') : ""} </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </Paper>
  )
}

MobileUserAccountPaymentDemandsList.propTypes = {
  notifications: PropTypes.array.isRequired,
};

export default MobileUserAccountPaymentDemandsList
